import {DateTime} from 'luxon';

import {useConstant} from '../../libs/shared/core/src/helpers/react/hooks/hookHelpers';
import {useEventHandler} from '../../libs/shared/core/src/helpers/react/hooks/useEventHandler';
import {useAppDispatch, useAppSelector} from '../../src/helpers/appReduxHelpers';
import {
  setDoNotDisturbEnd,
  setDoNotDisturbStart,
  tryFindDoNotDisturbInterval,
} from '../../src/helpers/models/doNotDisturbHelpers';
import {updateDoNotDisturbAction} from '../../src/store/data/preferences/preferencesActions';
import {getDoNotDisturb} from '../../src/store/data/preferences/preferencesSelectors';

/*
 * Hooks.
 */

export function useDoNotDisturb() {
  const dispatch = useAppDispatch();
  const doNotDisturb = useAppSelector(getDoNotDisturb);

  const onIsEnabledChange = useEventHandler((isEnabled: boolean) => {
    dispatch(updateDoNotDisturbAction({...doNotDisturb, isEnabled}));
  });

  const now = useConstant(() => DateTime.now());
  const interval = tryFindDoNotDisturbInterval(now, doNotDisturb);
  const onStartTimeChange = useEventHandler((time: DateTime) => {
    dispatch(updateDoNotDisturbAction(setDoNotDisturbStart(doNotDisturb, time)));
  });
  const onEndTimeChange = useEventHandler((time: DateTime) => {
    dispatch(updateDoNotDisturbAction(setDoNotDisturbEnd(doNotDisturb, time)));
  });

  return {
    isEnabled: doNotDisturb.isEnabled,
    onIsEnabledChange,
    interval,
    onStartTimeChange,
    onEndTimeChange,
  };
}
